import React from "react";
import "../../../../../../styles/ambassadorChallenge/referralTracking.scss";

const CheckIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_11208_69786)">
      <path
        d="M7.5 9.16667L10 11.6667L16.6667 5"
        stroke="#3A711A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6693 9.99967V14.9997C16.6693 15.4417 16.4937 15.8656 16.1811 16.1782C15.8686 16.4907 15.4446 16.6663 15.0026 16.6663H5.0026C4.56058 16.6663 4.13665 16.4907 3.82409 16.1782C3.51153 15.8656 3.33594 15.4417 3.33594 14.9997V4.99967C3.33594 4.55765 3.51153 4.13372 3.82409 3.82116C4.13665 3.5086 4.56058 3.33301 5.0026 3.33301H12.5026"
        stroke="#3A711A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_11208_69786">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const CircleIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.9974 1.66699C5.38906 1.66699 1.66406 5.39199 1.66406 10.0003C1.66406 14.6087 5.38906 18.3337 9.9974 18.3337C14.6057 18.3337 18.3307 14.6087 18.3307 10.0003C18.3307 5.39199 14.6057 1.66699 9.9974 1.66699ZM9.9974 16.667C6.3224 16.667 3.33073 13.6753 3.33073 10.0003C3.33073 6.32533 6.3224 3.33366 9.9974 3.33366C13.6724 3.33366 16.6641 6.32533 16.6641 10.0003C16.6641 13.6753 13.6724 16.667 9.9974 16.667ZM12.9891 5.83366L9.9974 8.82533L7.00573 5.83366L5.83073 7.00866L8.8224 10.0003L5.83073 12.992L7.00573 14.167L9.9974 11.1753L12.9891 14.167L14.1641 12.992L11.1724 10.0003L14.1641 7.00866L12.9891 5.83366Z"
      fill="#A8ABB4"
    />
  </svg>
);

const ReferralTrackingRow: React.FC<{ item: ReferralTracking }> = ({
  item,
}) => {
  return (
    <div className="rt-row">
      <div className="col id">{item.referrer_id}</div>

      <div className="col referrer">
        <div className="name">{item.referrer.name}</div>
      </div>

      <div className="col referred">
        <div className="name">{item.referred.name}</div>
      </div>

      <div className="col date">{item.referred.signup_date}</div>

      <div className="col progress">
        <div className="criteria-icons">
          <div
            className={`criterion ${
              item.referred.has_connection ? "done" : "todo"
            }`}
          >
            {item.referred.has_connection ? <CheckIcon /> : <CircleIcon />}
          </div>
          
          <div
            className={`criterion ${
              item.referred.profile_pass ? "done" : "todo"
            }`}
          >
             {item.referred.profile_pass ? <CheckIcon /> : <CircleIcon />}
          </div>
          <div
            className={`criterion ${
              item.referred.has_post ? "done" : "todo"
            }`}
          >
           {item.referred.has_post ? <CheckIcon /> : <CircleIcon />}
          </div>
        </div>

        {/* <div className="progress-bar-wrap" aria-hidden>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${item.referred.profile_completion}%` }}
            />
          </div>
        </div> */}

      </div>

      <div className="col status">
        {item.status === "Verified" ? (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_11208_69740)">
              <path
                d="M9 11L12 14L20 6"
                stroke="#3A711A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M20 12V18C20 18.5304 19.7893 19.0391 19.4142 19.4142C19.0391 19.7893 18.5304 20 18 20H6C5.46957 20 4.96086 19.7893 4.58579 19.4142C4.21071 19.0391 4 18.5304 4 18V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H15"
                stroke="#3A711A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_11208_69740">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        ) : (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.5 7H11V13L16.2 16.2L17 14.9L12.5 12.2V7Z"
              fill="#8D9199"
            />
          </svg>
        )}
        <div
          className={`status-badge ${
            item.status === "Verified" ? "verified" : "pending"
          }`}
        >
          {item.status}
        </div>
      </div>
    </div>
  );
};

export default ReferralTrackingRow;
